/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneAuthorDetails as ResolvedStandaloneAuthorDetails } from 'base/components/standalone/AuthorDetails';

export const AuthorDetails: typeof ResolvedStandaloneAuthorDetails = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneAuthorDetails {...props} />
        </ErrorBoundary>
    );
});

export type AuthorDetailsProps = PropsFromComponent<typeof AuthorDetails>;

/** @deprecated Use slot architecture instead */
export const AuthorDetailsWith = (extras: DynamicStandaloneExtras): typeof AuthorDetails => {
    return function AuthorDetails(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'AuthorDetails');
        return <ResolvedStandaloneAuthorDetails {...mergeProps({ options: { theme } }, props)} />;
    }
}